import { Tag } from 'antd';
import styled, { css } from 'styled-components';

export const PostWrapper = styled.div<{ $isfeatured?: boolean }>`
  position: relative;
  display: flex;
  padding: 16px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  cursor: pointer;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid transparent;
  ${({ $isfeatured }) =>
    $isfeatured &&
    css`
      background: ${({ theme }) => theme.colors.purple1};
    `}
  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.black3};
  }
  &:hover .post-actions {
    opacity: 1;
    visibility: visible;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  gap: 8px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  flex-shrink: 0;
  align-self: center;
`;

export const FeaturedTag = styled(Tag)`
  background: ${({ theme }) => theme.colors.purple6};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  margin-inline-end: 0 !important;
  border-radius: 4px;
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const StyledImage = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 4px;
  flex: none;
  object-fit: cover;
`;

export const ImagePlaceholder = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 4px;
  flex: none;
  background-color: ${({ theme }) => theme.colors.black2};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: ${({ theme }) => theme.colors.black5};
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  max-height: 108px;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: hidden;
  flex: 1;
  min-width: 0;
`;

export const HeadWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: ${({ theme }) => theme.colors.black5};
  text-overflow: ellipsis;

  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  flex-shrink: 1;

  > div,
  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 1;
    min-width: 0;
  }

  > span {
    flex-shrink: 0;
  }
`;

export const DateWrapper = styled.div<{ $isscheduled: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
  min-width: 0;

  ${({ $isscheduled }) =>
    $isscheduled &&
    css`
      color: ${({ theme }) => theme.colors.orange7};

      svg {
        fill: ${({ theme }) => theme.colors.orange7};
        flex-shrink: 0;
      }
    `}

  > div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const TitleWrapper = styled.div<{ $isFeatured?: boolean }>`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${({ $isFeatured }) => ($isFeatured ? 1 : 2)};
  line-clamp: ${({ $isFeatured }) => ($isFeatured ? 1 : 2)};
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  max-width: 100%;
`;
